<template>
  <!-- -->

  <Modal
    v-model="liveTops"
    width="500px"
    class-name="vertical-center-modal"
    @on-cancel="cancel"
  >
    <div style="min-height: 300px; padding: 40px 60px">
      <div class="zhuce">重置密码</div>

      <Form ref="formItem" :model="formItem" :rules="ruleInfo" :label-width="0">
        <div v-if="comlists == 0" key="12">
          <FormItem class="liItem">
            <img
              style="width: 22px; height: 25px"
              src="@/assets/images/inpone.png"
            />
            <Input
              height="50px"
              v-model="formItem.mobile"
              placeholder="请输入您的手机号"
              @keyup.enter.native="keyupClick('code')"
            >
            </Input>
          </FormItem>
          <FormItem class="liItem top_input">
            <img
              style="width: 23px; height: 25px"
              src="@/assets/images/dui.png"
            />
            <Input
              style="height: 50px"
              v-model="formItem.validateCode"
              placeholder="请输入动态密码"
              ref="code"
              @keyup.enter.native="next('mima')"
            ></Input>
            <Button
              v-show="codeList"
              @click="getCode('formItem')"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
              >获取验证码</Button
            >
            <Button
              v-show="!codeList"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
              >{{ times }}秒</Button
            >
          </FormItem>
          <FormItem>
            <Button
              style="width: 100%; height: 40px"
              @click="next('mima')"
              type="primary"
              >下一步</Button
            >
          </FormItem>
        </div>

        <div v-else-if="comlists == 1" key="34">
          <FormItem class="liItem myPasswordInput" prop="inputs">
            <img
              style="width: 22px; height: 25px"
              src="@/assets/images/suo.png"
            />
            <Input
              password
              height="50px"
              type="password"
              v-model="formItem.inputs"
              placeholder="请输入您的密码"
              ref="mima"
              @keyup.enter.native="keyupClick('mima2')"
            >
            </Input>
          </FormItem>
          <FormItem class="liItem myPasswordInput" prop="pwd">
            <img
              style="width: 22px; height: 25px"
              src="@/assets/images/suo.png"
            />
            <Input
              password
              height="50px"
              type="password"
              v-model="formItem.pwd"
              placeholder="请再次确认密码"
              ref="mima2"
              @keyup.enter.native="nextlives('formItem')"
            >
            </Input>
            <div class="passwor" @click="forget()">返回登录</div>
          </FormItem>
          <FormItem>
            <Button
              style="width: 100%; height: 40px"
              @click="nextlives('formItem')"
              type="primary"
              >确定</Button
            >
          </FormItem>
        </div>
      </Form>
    </div>
    <div slot="footer"></div>
    <VerifyCode
        ref="verifyCode"
        :show="showVerifyCode"
        :phone="formItem.mobile"
        @success="handleVerifySuccess"
        @close="handleVerifyClose"
      ></VerifyCode>
  </Modal>
</template>
<script>
import {
  email,
  realName,
  select,
  upload,
  empty,
  phone,
  password,
  identity,
  verificationCode,
  pws,
  selectcity
} from '@/const/formValidate'
import DataApi from '@/api/login'
import VerifyCode from '@/views/home/components/VerifyCode.vue'
var vm
export default {
  props: ['liveTop', 'comlist'],
  name: '',
  data () {
    return {
      showVerifyCode: false,
      formItem: {
        inputs: '',
        mobile: '',
        validateCode: '',
        pwd: ''
      },
      liveTops: this.liveTop,
      comlists: this.comlist,
      ruleInfo: { inputs: empty('你的密码'), pwd: empty('你的密码') },
      git_live: false,
      times: '', // 验证码获取时间
      codeList: true,
      count: null
    }
  },
  components: { VerifyCode },
  created () {
    vm = this
  },
  watch: {
    liveTop (item) {
      this.liveTops = item
    },
    comlist (item) {
      this.comlists = item
    }
    // comlist(item) {
    //   this.comlist = item;
    // },
  },
  mounted () {
    this.comlists = this.comlist
    // this.comlist = this.liveTop;
    // if (this.liveTop) {
    //   this.comlist = true;
    // } else {
    //   this.comlist = false;
    // }
  },
  methods: {
    keyupClick (name) {
      this.$nextTick(() => {
        vm.$refs[name].focus()
      })
    },
    next (name) {
      var phoneList = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      var texList = /^[0-9]{6}$/

      if (this.formItem.mobile == '') {
        this.$Message.error('请输入手机号!')
        return
      } else if (!phoneList.test(vm.formItem.mobile)) {
        this.$Message.error('手机号码格式有误!')
        return
      }

      if (!this.$refs.verifyCode.isSuccess) {
        this.showVerifyCode = true
        return
      }

      if (texList.test(vm.formItem.validateCode)) {
        vm.comlists = 1
      } else {
        this.$Message.destroy()
        this.$Message.error('验证码格式有误!')
      }
      vm.keyupClick(name)
    },
    forget () {
      this.liveTops = false
      this.formItem = {
        inputs: '',
        mobile: '',
        validateCode: '',
        pwd: ''
      }
      this.codeList = true
      vm.$emit('passwords', vm.liveTops)
    },
    nextlives (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.formItem.inputs == this.formItem.pwd) {
            var data = {
              mobile: vm.formItem.mobile,
              validateCode: vm.formItem.validateCode,
              pwd: vm.formItem.pwd
            }
            DataApi.userRetrievePwd(data).then(res => {
              if (res.resultCode == 200) {
                this.$Message.success('修改成功,请重新登录!')
                this.formItem = {
                  inputs: '',
                  mobile: '',
                  validateCode: '',
                  pwd: ''
                }
                this.codeList = true

                this.liveTops = false
                vm.$emit('passwords', vm.liveTops)
              } else {
                this.$Message.destroy()
                this.$Message.warning(res.resultDesc)
              }
            })
          } else {
            this.$Message.destroy()
            this.$Message.error('您的密码不一致!')
          }
        } else {
          this.$Message.destroy()
          this.$Message.error('请填写你的密码!')
        }
      })
    },
    getCode (name) {
      // this.$refs[name].validate((valid) => {
      //   if (valid) {
      var inputs = /^1[3456789]\d{9}$/

      if (vm.formItem.mobile == '') {
        this.$Message.error('请输入手机号!')
        return
      } else if (!inputs.test(vm.formItem.mobile)) {
        this.$Message.error('手机号格式有误!')
        return
      }

      // 校验手机号是否注册
      DataApi.accountIsExist({
        account: vm.formItem.mobile
      }).then(res => {
        if (res.data) {
          return this.$Message.error('该手机号未注册')
        }
        this.showVerifyCode = true
      })
    },
    handleVerifyClose () {
      this.showVerifyCode = false
    },
    handleVerifySuccess () {
      this.showVerifyCode = false
      if (this.times) return
      this.yanzheng()
    },
    yanzheng () {
      var data = {
        phone: vm.formItem.mobile,
        adapter: 'retrieve_pwd'
      }
      DataApi.regiteList(data)
        .then(res => {
          if (res.messageType == 'Success') {
            this.$Message.success('发送成功!')
            const TIME_COUNT = 60
            this.times = TIME_COUNT
            this.codeList = false
            this.times = 60
            var count = setInterval(() => {
              this.times--
              if (this.times <= 0) {
                this.codeList = true
                clearInterval(count)
              }
            }, 1000)
          } else {
            this.$Message.destroy()
            this.$Message.error('发送失败!')
          }
        })
        .catch(err => {})
    },

    cancel () {
      vm.liveTops = false
      vm.$emit('passwords', vm.liveTops)
    }
  }
}
</script>
<style scoped="scoped" lang="less">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 24px;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.passwor {
  text-align: right;
  cursor: pointer;
}

.myPasswordInput /deep/ .ivu-icon {
  font-size: 22px;
  line-height: 42px;
}
</style>
